const IS_DEV = process.env.NODE_ENV === 'development';
const isInternal = () => window.location.hostname.indexOf('internal') > -1;
const isDev = () => IS_DEV;
const isProd = () => window.location.hostname === "fearlessleague.com";

/**
 * @return {boolean} True if the user is in the admin environment of the website
 * (to manage users/subscription rules/etc)
 */
const isInAdminEnvironment = () => window.location.pathname.startsWith('/admin/');
const isInUserEnvironment = () => window.location.pathname.startsWith('/user');

export {
    isInternal,
    isDev,
    IS_DEV,
    isProd,
    isInAdminEnvironment,
    isInUserEnvironment
}
